import React from 'react';
import { Content, Button } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import Unactivated from '../../resultRenderers/Unactivated';
import S from '../../PairForm.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LocatorUnactivated(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    titleVariant,
    titleIcon,
    onOkay: pOnOkay,
    onSetField
  } = props;
  const onOkay = evt => {
    pOnOkay(evt);
    onSetField({
      data: 'trackerId',
      value: null
    });
  };
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Pair Locator to Vehicle",
        icon: titleIcon,
        children: /*#__PURE__*/_jsx(Button, {
          variant: "closeDialog",
          className: S.close,
          onClick: onClose
        })
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      style: {
        maxHeight: '75vh'
      },
      className: areaClassName,
      children: /*#__PURE__*/_jsx(Unactivated, {})
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "secondary",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "button.pairing.unactivatedReturnToForm",
        variant: "primary",
        onClick: onOkay,
        children: "Proceed"
      })]
    })]
  });
}